// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__VbqMB","title":"BackImages_title__3Cjf6","images":"BackImages_images__3oxt7"};